export enum FsGeospatialProvider {
  GoogleMaps = 'googlemaps',
  EsriArcGIS = 'esri',
  AxonEsri = 'cartographer',
}
